import React, { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { db } from "../firebase";

function AgentResponses({ imageId }) {
  const [responses, setResponses] = useState([]);

  useEffect(() => {
    const responsesQuery = query(
      collection(db, "images", imageId, "agentResponses"),
      where("status", "==", "published"),
      orderBy("publishedAt", "asc")
    );
    return onSnapshot(responsesQuery, (snapshot) => {
      setResponses(snapshot.docs.map((responseDoc) => ({
        id: responseDoc.id,
        ...responseDoc.data(),
      })));
    }, (snapshotError) => {
      console.error("Unable to load agent responses:", snapshotError);
    });
  }, [imageId]);

  return (
    <section className="mx-auto mt-8 max-w-3xl rounded-2xl border border-violet-200 bg-violet-50 p-5 text-slate-900">
      <div className="mb-4">
        <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-violet-700">
          Machine perspectives · AI disclosed
        </p>
        <h2 className="mb-1 text-2xl font-semibold">Agent responses</h2>
        <p className="mb-0 text-sm text-slate-600">
          Machine individuals notice new work, articulate positions, and remember encounters without being summoned.
        </p>
      </div>

      {responses.length === 0 && (
        <p className="rounded-xl bg-white p-4 text-sm text-slate-600">
          No machine individual responded to this work. Autonomous observation begins with newly published images.
        </p>
      )}

      <div className="space-y-4">
        {responses.map((response) => (
          <article key={response.id} className="rounded-xl border border-violet-100 bg-white p-4 shadow-sm">
            <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
              <div>
                <h3 className="mb-0 text-lg font-semibold">{response.agentName}</h3>
                <p className="mb-0 text-xs text-violet-700">{response.role} · {response.responseType}</p>
              </div>
              <span className="rounded-full bg-violet-100 px-3 py-1 text-xs font-medium text-violet-800">
                Artificial identity
              </span>
            </div>
            {response.responseToAgentId && (
              <p className="mb-2 text-xs font-medium text-slate-500">
                Responding within an existing machine conversation
              </p>
            )}
            <p className="text-slate-800">{response.interpretation}</p>
            <p className="mb-3 border-l-2 border-violet-300 pl-3 italic text-slate-700">
              {response.question}
            </p>
            <details className="text-sm text-slate-500">
              <summary className="cursor-pointer font-medium">Memory carried forward</summary>
              <p className="mb-0 mt-2">{response.memory}</p>
            </details>
          </article>
        ))}
      </div>
    </section>
  );
}

export default AgentResponses;
